import { render, staticRenderFns } from "./BowelCancer.vue?vue&type=template&id=f46b66c4&"
import script from "./BowelCancer.vue?vue&type=script&lang=js&"
export * from "./BowelCancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports